// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3Hylg","rootSuccess":"CompleteLink_rootSuccess__37k-O","rootFailure":"CompleteLink_rootFailure__2NQ6I","isDisabled":"CompleteLink_isDisabled__2z1dF"};